<template>
  <TopNav></TopNav>
  <h1>İndirim Hesaplama</h1>
  <fieldset>
    <legend>İndirim Hesaplama Aracı</legend>
    <label for="a">Normal Fiyat:</label><input type="number" v-model.number="normalFiyat" id="a" step="any"> ₺
    <br>
    <label for="b">İndirim Oranı:</label><input type="number" v-model.number="indirimOrani" id="b" step="any"> %
    <br><br>
    İndirimli Fiyat: <span class="blue">{{ indirimliFiyat() }} ₺</span>
  </fieldset>
</template>

<script>
import TopNav from './components/TopNav.vue'

export default {
  name: "Indirim",
  data() {
    return {
      normalFiyat: 1000,
      indirimOrani: 15,
    }
  },
  components: {
    TopNav
  },
  methods: {
    indirimliFiyat: function () {
      const indirim = this.normalFiyat - this.normalFiyat * this.indirimOrani / 100;
      const indirimNumber = Number(indirim);
      const formatter = new Intl.NumberFormat('tr-TR', {
        minimumFractionDigits: 0,
        maximumFractionDigits: 2,
      });

      return formatter.format(indirimNumber);
    },
  },
};
</script>

<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  margin-top: 60px;
}

body {
  margin: 1em auto;
  margin-top: 0;
  max-width: 40em;
  font-family: Arial, Helvetica, sans-serif;
}

label {
  display: inline-block;
  min-width: 125px;
}

footer section a {
  margin: 20px;
}

.blue {
    color: blue;
}
</style>
